<template>
    <div class="max-w-6xl mx-auto p-6 space-y-12">
        <div class="text-center">
            <h1 class="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
                Giới thiệu các Gói Phần Mềm
            </h1>
            <p class="text-lg text-gray-600">
                Lựa chọn giải pháp phù hợp cho lĩnh vực của bạn
            </p>
        </div>

        <div class="grid md:grid-cols-2 gap-8">
            <!-- Gói Xuất Nhập Khẩu -->
            <div class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-xl transition duration-300">
                <h2 class="text-2xl font-semibold text-blue-500 mb-4">
                    Gói Xuất Nhập Khẩu
                </h2>
                <ul class="space-y-2 text-gray-700">
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Quản lý lô hàng
                        </span>
                    </li>
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Theo dõi tiến độ vận chuyển
                        </span>
                    </li>
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Tích hợp email và nhắc lịch xử lý
                        </span>
                    </li>
                </ul>
                <div class="mt-6">
                    <hts-form-button
                        color="primary"
                        @click="handleUpgrate('IMPORT_AND_EXPORT')">
                        Nâng cấp gói
                    </hts-form-button>
                </div>
            </div>

            <!-- Gói Nhà Xe -->
            <div class="bg-white shadow-lg rounded-2xl p-6 hover:shadow-xl transition duration-300">
                <h2 class="text-2xl font-semibold text-green-600 mb-4">
                    Gói Dịch Vụ Dành Cho Nhà Xe
                </h2>
                <ul class="space-y-2 text-gray-700">
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Quản lý đội xe, tài xế và đối tác vận tải
                        </span>
                    </li>
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Tạo và quản lý báo giá vận chuyển
                        </span>
                    </li>
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Quản lý đơn hàng
                        </span>
                    </li>
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Điều phối xe, theo dõi và cập nhật trạng thái chuyến hàng
                        </span>
                    </li>
                    <li class="flex items-start gap-2">
                        <span>
                            ✅
                        </span> <span>
                            Giám sát chuyến hàng theo thời gian thực
                        </span>
                    </li>
                </ul>
                <div class="mt-6">
                    <hts-form-button
                        color="success"
                        @click="handleUpgrate('VENDOR')">
                        Nâng cấp gói
                    </hts-form-button>
                </div>
            </div>
        </div>

        <hts-modal
            :show="showUpgradeModal"
            :title="upgrateTitle"
            @hide="showUpgradeModal = false">
            <hts-form @submit="submitUpgrade">
                <div class="space-y-4">
                    <hts-card :title="$t('labels.workspace')">
                        <hts-form-input
                            v-model="upgradeForm.wsName"
                            label="Tên Workspace"
                            name="wsName"
                            prop="wsName" />
                    </hts-card>

                    <hts-card :title="$t('labels.company')">
                        <hts-form-input
                            v-model="upgradeForm.companyName"
                            label="Tên Công Ty"
                            required
                            name="companyName"
                            prop="companyName" />
                        <hts-form-input
                            v-model="upgradeForm.email"
                            label="Email"
                            type="email"
                            name="email"
                            prop="email" />

                        <hts-form-phone
                            v-model="upgradeForm.phone"
                            :label="$t('labels.phoneRegister')"
                            name="phone"
                            prop="phone" />
                    </hts-card>
                </div>
                <div class="mt-6 text-right">
                    <hts-form-button
                        type="submit"
                        color="primary">
                        Xác nhận
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
    </div>
</template>

<script lang="ts" setup>
const showUpgradeModal = ref<boolean>(false)
const typeUpgrade = ref<string>('')

const upgradeForm = ref({
  wsName: '',
  companyName: '',
  email: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  }
})

const upgrateTitle = computed(() => {
  if (typeUpgrade.value === 'VENDOR') {
    return 'Thông tin nâng cấp gói dành cho Nhà xe'
  }

  return 'Thông tin nâng cấp gói xuất nhập khẩu'
})
const handleUpgrate = (type: string) => {
  typeUpgrade.value = type
  showUpgradeModal.value = true
}

const submitUpgrade = () => {
  const api = {
    url: '/upgrate',
    method: 'post'
  }
  $api(api, { body: { type: typeUpgrade.value, ...upgradeForm.value } }).then((data: any) => {})
}
</script>
